<template lang="pug">
    .settings(v-if='settings')
        template
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers') }}: {{ settings.amountOfNumbers }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}: {{ settings.amountOfOpenedFields }}
            br
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_repeatedNumbers') }}: {{ settings.repeatedNumbers }}
            br
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
    };
</script>
